import { render, staticRenderFns } from "./ECN2024StudentGameChangerCareerPanel.vue?vue&type=template&id=b0476c28&scoped=true"
import script from "./ECN2024StudentGameChangerCareerPanel.vue?vue&type=script&lang=js"
export * from "./ECN2024StudentGameChangerCareerPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0476c28",
  null
  
)

export default component.exports